import { Injectable } from '@angular/core';
import { getTimezone } from '../../dataprotection-common/utils';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  getRestorePointsForVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/backups?timezone=' + encodeURIComponent(getTimezone());
    return this.http
      .get(url)
      .map(
        (res: any) => this.value = res
      );
  }

  getRestorePointsForDeletedVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/deletedVApp/' + vappId + '/backups?timezone=' + encodeURIComponent(getTimezone());
    return this.http
      .get(url)
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/restore-points/restore-points.service.ts